import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InventoryHotelsService } from 'src/app/business-service/inventory/inventory-hotels.service';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';

@Component({
  selector: 'app-vehicle-auto-complete',
  templateUrl: './vehicle-auto-complete.component.html',
  styleUrls: ['./vehicle-auto-complete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: VehicleAutoCompleteComponent,
      multi: true
    }
  ]
})
export class VehicleAutoCompleteComponent  implements OnInit {
  @Input() placeHolder: string = "-- select an option --";
    @Output() predictionSelected: EventEmitter<any> = new EventEmitter();
    disabled: boolean = false;
    @Input() locationvalue: any;
  
    vendorName: string = "";
    predictions: any;
  
    private onChange: (value: any) => void = () => { };
    private onTouched: () => void = () => { };

  constructor(
  private _elementRef: ElementRef,
    private _hotelService: InventoryHotelsService,
    private _inventoryService: InventoryService,

  ) { }

  ngOnInit() {}

  
    onInput(event: any) {
      const locationvalue = this.locationvalue;
      const input = event;
      this._inventoryService.getVehicleByLocation(locationvalue).subscribe(
        response => {
          // Filter out hotels with status 'Inactive'
          this.predictions = response.filter((vehicle: any) => vehicle.status !== 'Inactive' &&  vehicle.transferDetails.vendorName.includes(event));
        },
        error => {
          console.error("error of api", error);
        }
      )
    }
  
    selectPrediction(prediction: any) {
      this.vendorName = prediction?.transferDetails?.vendorName;
  
      this.predictionSelected.emit(prediction);
      this.predictions = [];
      this.onChange(this.vendorName); // Notify the form about the selected value
    }
  
    @HostListener('document:click', ['$event'])
    handleOutsideClick(event: MouseEvent) {
      const targetElement = event.target as HTMLElement;
      if (!this._elementRef.nativeElement.contains(targetElement)) {
        this.predictions = [];
      }
    }
    // ControlValueAccessor methods
    writeValue(value: any): void {
      if (value !== undefined) {
        this.vendorName = value; // Handle both selected value or free-text
      }
    }
  
    // register the changes 
    registerOnChange(fn: any): void {
      this.onChange = fn;
    }
  
    // register when touched
    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }
    // handle disable state
    setDisabledState(isDisabled: boolean): void {
      this.disabled = isDisabled;
    }
      // Method to handle free text input changes
      onFreeTextInput(event: any) {
        this.onChange(this.vendorName); // Notify the form about free text value
      }

}
